import {editorProps} from '../../slack';
import {DEFAULT_SLACK_MESSAGE} from './constants';

export const createDefaultContent = (
  integrationId: string | null = null,
) => {
  return {
    editor_mode: 'wysiwyg_mode',
    channels: [],
    value_html: '',
    value_markdown: '',
    value_json: DEFAULT_SLACK_MESSAGE,
    integration_id: integrationId,
    send_with_all_attachments: true,
    merge_pdf_config: {},
    merge_csv_config: {},
  }
};

export const toBlockKitURL = (valueJSON: any) => {
  return encodeURIComponent(valueJSON);
}

export const initialProps = () => {
  /*
   * Extend editor props and override the desired values in order to add `merge_tags`.
   */
  const _editorProps = editorProps();

  return {
    ..._editorProps,
    setup: (editor: any) => {
      _editorProps.setup(editor);
    }
  }
}
